import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { acoes, enums, routes } from '../../../constants'
import { actions } from '../lancamento.actions'
import { LancamentoForm } from './LancamentoForm'
import utils from '../../../utils/index'
import storage from '../../../services/stoage.service'
import '../../../index.scss'
import './LancamentoForm.scss'
import _ from 'lodash'
import {
  fuAfterLoad,
  fuAfterNew,
  fuAtualizarProvisionamento,
  fuBeforeFetchRecordSuccess,
  fuCalcularValorParcela,
  fuCalcularValorTotal,
  fuChangeHandlerFormaPagamento,
  fuChangeHandlerValorLancamento,
  fuCheckDocumentoPagador,
  fuComponentDidMount,
  fuComponentDidUpdate,
  fuEditarNumeroParcelas,
  fuEnviarWhatsApp,
  fuEstornarLancamento,
  fuDispararEstorno,
  fuExecutarBaixaLancamento,
  fuAbrirDialogBoletoIndividual,
  fuGerarBoletoIndividual,
  fuGerarCarneParcelas,
  fuGetBotoesPersonalizados,
  fuGetDialogCancelarReabrir,
  fuGetDialogConfirmarFecharPedido,
  fuGetDialogConfirmarReajustarLancamento,
  fuGetDialogDadosBaixaParcela,
  fuGetDialogDadosBoletoIndividual,
  fuGetDialogEstornar,
  fuGetLoadingEstorno,
  fuGetDialogEstornarParcelas,
  fuGetDialogUnirLancamento,
  fuGetModalBaixarLancamento,
  fuGetModalEmitirNFSe,
  fuHideDialog,
  fuLookupPagadorOnCancel,
  fuLookupPagadorOnClick,
  fuLookupPagadorOnConfirm,
  fuLookupPagadorOnEdit,
  fuLookupPagadorOnFilter,
  fuLookupPagadorOnHide,
  fuLookupPagadorOnInputFilter,
  fuLookupPagadorOnKeyPress,
  fuLookupPagadorOnPage,
  fuLookupPagadorOnSort,
  fuOnBlurConspagaPagarAte,
  fuOnBlurNumeroParcelas,
  fuOnBlurValorDescontoAcrescimo,
  fuOnBlurValorFormaPagamento,
  fuOnBlurValorParcela,
  fuOnChangeHandlerConspagaPagarAte,
  fuOnChangeJurosDia,
  fuOnChangePercentualDesconto,
  fuOnChangePercentualJuros,
  fuOnChangePercentualMulta,
  fuOnChangeTipoDesconto,
  fuOnChangeTipoJuros,
  fuOnChangeTipoMulta,
  fuOnChangeValorDesconto,
  fuOnChangeValorJuros,
  fuOnChangeValorMulta,
  fuOnClickAdicionarParcela,
  fuOnClickBaixarLancamentos,
  fuOnResponseGetPacoteTaxas,
  fuRealizarBaixaLancamento,
  fuSetContaCorrente,
  fuSetContrato,
  fuSetFieldPagador,
  fuSetNotaEntrada,
  fuVerificarGeracaoBoletoIndividual,
  mapDispatchToPropsLancamento,
  mapStateToPropsLancamento,
} from '../../../utils/lancamento-form-utils'
import {
  formActionPagamento,
  formColumnData,
  formColunasPagamento,
  fuAbrirLancamento,
  fuDesabilitarBotaoAdicionarPagamento,
  fuDesabilitarBotaoBaixarParcela,
  fuDesabilitarBotaoBoleto,
  fuDesabilitarBotaoCarne,
  fuDesabilitarBotaoEstornarParcela,
  fuGetValorLancamentosFilhos,
  fuOnChangeItemLancamento,
  fuSetMarcadores,
  fuShowFormParcelas,
} from '../../../utils/lancamento/form/form-render'

let self

const mapStateToProps = (state) => {
  return mapStateToPropsLancamento(state)
}
const mapDispatchToProps = (dispatch) => {
  return mapDispatchToPropsLancamento(dispatch)
}

class LancamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    this.state = {
      ACAO_CANCELAR_LANCAMENTOS: storage.getAcao(acoes.ACAO_CANCELAR_LANCAMENTOS),
      ACAO_UNIR_LANCAMENTOS: storage.getAcao(acoes.ACAO_UNIR_LANCAMENTOS),
      BLOQUEAR_LANCAMENTO: storage.getAcao(acoes.BLOQUEAR_LANCAMENTO),
      ALTERAR_VENDEDOR: storage.getAcao(acoes.ALTERAR_VENDEDOR),
      ALTERAR_AUXILIAR: storage.getAcao(acoes.ALTERAR_AUXILIAR),
      ESTORNAR_LANCAMENTO: storage.getAcao(acoes.ESTORNAR_LANCAMENTO),
      FECHAR_PEDIDO_STONE: storage.getAcao(acoes.FECHAR_PEDIDO_STONE),
      ACAO_REAJUSTAR_LANCAMENTOS: storage.getAcao(acoes.ACAO_REAJUSTAR_LANCAMENTOS),
      ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO: storage.getAcao(acoes.ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO),
      paramBaixarLancamento: {
        oidLancamento: '',
        valorPago: '',
        dataPagamento: '',
        formaPagamento: '',
      },
      activeIndex: 0,
      oidLancamentoUnir: '',
      showConfirmarEstornar: false,
      estornoEmAndamento: false,
      showDialogRemove: false,
      showConfirmarUnirLancamento: false,
      showConfirmarCancelarReabrir: false,
      showConfirmarEstornarParcelas: false,
      showConfirmarFecharPedido: false,
      showConfirmarReajusteLancamento: false,
      screenWidth: null,
    }

    this.lancamentoCancelarReabrir = null

    actions.carregarMensageria = (mensagem) => {
      props.history.push('/geral/cadastros/mensageria', { mensagem })
    }
    actions.beforeFetchRecordSuccess = (data) => {
      return fuBeforeFetchRecordSuccess(data)
    }

    actions.onResponseGetPacoteTaxas = (taxaSelecionada, pacoteTaxas) => {
      fuOnResponseGetPacoteTaxas(taxaSelecionada, pacoteTaxas, this)
    }

    actions.afterSave = (data) => {
      this.props.history.replace(`${routes.PATH_LANCAMENTO_FINANCEIRO}/${data.oid}`)
      // phoenix-937: ao salvar um lançamento com forma PIX Imediato, gera a cobrança
      // automaticamente para que o copia-e-cola (e o QR) apareçam logo após o save — a empresa
      // repassa o copia-e-cola ao pagador. NÃO bloqueia nada: o lançamento fica EM_ABERTO e a
      // baixa chega depois pelo webhook/reconciliação (ou pelo botão "Atualizar Status Pix").
      // A geração é idempotente no backend (não recria cobrança viva/paga).
      const formaId = _.get(data, 'tipoFormaPagamento.id', -1)
      if (formaId === enums.ID_FORMA_PAGTO_PIX_IMEDIATO && _.get(data, 'oid')) {
        this.props.gerarPixImediato(data.oid)
      }
    }

    actions.afterNew = () => {
      fuAfterNew(this, routes.PATH_LANCAMENTO_FINANCEIRO)
    }

    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_LANCAMENTO_FINANCEIRO}`)
    }

    actions.afterLoad = () => {
      fuAfterLoad(this)
    }

    actions.afterEmitirNFSe = () => {
      fuGetBotoesPersonalizados(this)
    }

    actions.afterGetDescontosMultasJuros = () => {
      this.props.showForm('baixarParcelas', true)
      fuGetDialogDadosBaixaParcela(this)
    }

    this.setField = props.setField
    self = this
  }

  componentDidMount() {
    fuComponentDidMount(this)
  }

  componentWillUnmount() {}

  updateWindowDimensions() {
    this.setState({ screenWidth: window.innerWidth })
  }

  componentDidUpdate(anteriorProps) {
    fuComponentDidUpdate(anteriorProps, this)
  }

  searchHandler = () => {
    this.props.newHandler()
    this.props.history.push(`${routes.PATH_LANCAMENTO_FINANCEIRO}`)
  }

  onSelectionChange = (e) => {
    this.props.setSelectedParcelas(e.value)
  }

  editarNumeroParcelas = (e) => {
    fuEditarNumeroParcelas(e, this)
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  //TODO - verificar se ainda e usado - alterado para ltsCurrency
  onBlurValorDescontoAcrescimo = (e) => {
    fuOnBlurValorDescontoAcrescimo(e, this)
  }

  onBlurValor = (e) => {
    fuCalcularValorParcela(this)
  }

  onBlurValorFormaPagamento = (lancamento, e) => {
    fuOnBlurValorFormaPagamento(lancamento, e, this)
  }

  onBlurValorParcela = (e) => {
    fuOnBlurValorParcela(e, this)
  }

  onBlurNumeroParcelas = (e) => {
    fuOnBlurNumeroParcelas(e, this)
  }

  //metodo chamado somennte ao alterar campos que impactem o valor;
  // TODO - verificar se ainda e usado
  changeHandlerValorLancamento = (e) => {
    fuChangeHandlerValorLancamento(e, this)
  }

  onChangeJurosDia = (e) => {
    fuOnChangeJurosDia(e, this)
  }

  recalcularValorLancamento = () => {
    setTimeout(() => {
      this.props.recalcularValorLancamento()
    }, 200)
  }

  onChangeTipoDesconto = (event) => {
    fuOnChangeTipoDesconto(event, this)
  }

  onChangeValorDesconto = (value) => {
    fuOnChangeValorDesconto(value, this)
  }

  onChangePercentualDesconto = (value) => {
    fuOnChangePercentualDesconto(value, this)
  }

  onChangeTipoMulta = (event) => {
    fuOnChangeTipoMulta(event, this)
  }

  onChangeValorMulta = (value) => {
    fuOnChangeValorMulta(value, this)
  }

  onChangePercentualMulta = (value) => {
    fuOnChangePercentualMulta(value, this)
  }

  onChangeTipoJuros = (event) => {
    fuOnChangeTipoJuros(event, this)
  }

  onChangeValorJuros = (value) => {
    fuOnChangeValorJuros(value, this)
  }

  onChangePercentualJuros = (value) => {
    fuOnChangePercentualJuros(value, this)
  }

  onBlurConspagaPagarAte = (e) => {
    fuOnBlurConspagaPagarAte(e, this)
  }

  onChangeHandlerConspagaPagarAte = (taxa, e) => {
    fuOnChangeHandlerConspagaPagarAte(taxa, e, this)
  }

  changeHandlerFormaPagamento = (event) => {
    fuChangeHandlerFormaPagamento(event, this)
  }

  calcularValorTotal = (valorBruto) => {
    return fuCalcularValorTotal(valorBruto, this)
  }

  //REFERENTE AO LOOKUP DE PAGADOR
  lookupPagadorOnPage = (e) => {
    fuLookupPagadorOnPage(e, this)
  }

  lookupPagadorOnSort = (e) => {
    fuLookupPagadorOnSort(e, this)
  }

  lookupPagadorOnFilter = (e) => {
    fuLookupPagadorOnFilter(e, this)
  }

  lookupPagadorOnClick = (e) => {
    fuLookupPagadorOnClick(e, this)
  }

  lookupPagadorOnHide = (e) => {
    fuLookupPagadorOnHide(e, this)
  }

  lookupPagadorOnConfirm = (e) => {
    fuLookupPagadorOnConfirm(e, this)
  }

  setFieldPagador = (oid, nome, numeroDocumento) => {
    fuSetFieldPagador(oid, nome, numeroDocumento, this)
  }

  checkDocumentoPagador = (value) => {
    fuCheckDocumentoPagador(value, this)
  }

  lookupPagadorOnCancel = (e) => {
    fuLookupPagadorOnCancel(e, this)
  }

  lookupPagadorOnEdit = () => {
    fuLookupPagadorOnEdit(this)
  }

  lookupPagadorOnComplete = (e) => {}

  lookupPagadorOnInputFilter = (e) => {
    fuLookupPagadorOnInputFilter(e, this)
  }

  lookupPagadorOnKeyPress = (e) => {
    fuLookupPagadorOnKeyPress(e, this)
  }

  // REFERENTE AO LOOKUP PARA CONTRATO
  setContrato = (data) => {
    fuSetContrato(data, this)
  }

  setNotaEntrada = (data) => {
    fuSetNotaEntrada(data, this)
  }

  setContaCorrente = (data) => {
    fuSetContaCorrente(data, this)
  }

  hideDialog = () => {
    fuHideDialog(this)
  }

  hideBotaoRemover = () => {
    return true
  }

  calcularValorParcela = () => {
    fuCalcularValorParcela(this)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  realizarBaixaLancamento = () => {
    fuRealizarBaixaLancamento(this)
  }

  executarBaixaLancamento = () => {
    fuExecutarBaixaLancamento(this)
  }

  verificarGeracaoBoletoIndividual = (lancamento) => {
    fuVerificarGeracaoBoletoIndividual(lancamento, this)
  }

  getBotoesPersonalizados = () => {
    return fuGetBotoesPersonalizados(this)
  }

  abrirDialogBoletoIndividual = () => {
    fuAbrirDialogBoletoIndividual(this)
  }

  gerarBoletoIndividual = () => {
    fuGerarBoletoIndividual(this)
  }

  gerarCarneParcelas = () => {
    fuGerarCarneParcelas(this)
  }

  cancelarReabrir = () => {
    if (this.lancamentoCancelarReabrir && utils.isNumber(this.lancamentoCancelarReabrir.oid)) {
      this.props.cancelarReabrir(this.lancamentoCancelarReabrir.oid)
    }
  }

  onHideModalBaixarLancamento() {
    self.props.showForm('baixar', false)
  }

  confirmarBaixa({ valor, data, formaPagamento, lancamentos }) {
    const oidsLancamentos = lancamentos.map((l) => l.oid)
    const params = {
      oidsLancamentos,
      valor,
      data,
      formaPagamento,
    }
    self.props.executarBaixaLancamentos(params)
    self.onHideModalBaixarLancamento()
  }

  abrirLancamento = (oidLancamento) => {
    fuAbrirLancamento(oidLancamento, this, routes.PATH_LANCAMENTO_FINANCEIRO)
  }

  desabilitarBotaoAdicionarPagamento = () => {
    return fuDesabilitarBotaoAdicionarPagamento(this)
  }

  desabilitarBotaoEstornarParcela = () => {
    return fuDesabilitarBotaoEstornarParcela(this)
  }

  desabilitarBotaoBaixarParcela = () => {
    return fuDesabilitarBotaoBaixarParcela(this)
  }

  desabilitarBotaoBoleto = () => {
    return fuDesabilitarBotaoBoleto(this)
  }

  desabilitarBotaoCarne = () => {
    return fuDesabilitarBotaoCarne(this)
  }

  estornarLancamento = (oidsLancamentos) => {
    fuEstornarLancamento(oidsLancamentos, this)
  }

  executarEstorno = () => {
    fuDispararEstorno(this.lancamentosEstornar, this)
  }

  estornarParcelas = () => {
    this.setState({ showConfirmarEstornarParcelas: true })
  }

  getValorLancamentosFilhos = () => {
    return fuGetValorLancamentosFilhos(this)
  }

  disabledBotaoBoleto = (lancamento) => {
    return !(
      lancamento.oid &&
      lancamento.oid !== '' &&
      lancamento.tipoFormaPagamento &&
      lancamento.tipoFormaPagamento.id === 5
    )
  }

  onClickAdicionarParcela = () => {
    fuOnClickAdicionarParcela(this).then()
  }

  showFormParcelas = () => {
    fuShowFormParcelas(this)
  }

  fnUpdateObservacao = (data) => {
    if (!_.isEmpty(data)) {
      this.setObservacaoLancamento(data)
    }
  }

  onChangeItemLancamento = (data) => {
    fuOnChangeItemLancamento(data, this)
  }

  setObservacaoLancamento = (data) => {
    const observacao = _.get(this, 'props.record.observacao', null)
    if ((!observacao || _.trim(observacao).length === 0) && data) {
      this.setField('observacao', data)
    }
  }

  setMarcadores = (data) => {
    fuSetMarcadores(data, this)
  }

  enviarWhatsApp = (oidLancamento) => {
    fuEnviarWhatsApp(oidLancamento, this)
  }

  atualizarProvisionamento = () => {
    fuAtualizarProvisionamento(this.props.record, this)
  }

  emitirNFSe = ({ oidLancamento, descricaoNFSe, oidPagador }) => {
    this.props.emitirNotaFiscalServico({ oidLancamento, descricaoNFSe, oidPagador })
  }

  onClickBaixarParcela = () => {
    fuOnClickBaixarLancamentos(this)
  }

  render() {
    const actionPagamento = (rowData) => {
      return formActionPagamento(rowData, this)
    }

    const columnData = (rowData, column) => {
      return formColumnData(rowData, column, this, routes.PATH_LANCAMENTO_FINANCEIRO)
    }

    const colunasPagamento = formColunasPagamento(this, columnData, actionPagamento)
    const content = (
      <div>
        {fuGetModalEmitirNFSe(this)}
        {fuGetModalBaixarLancamento(this)}
        {fuGetDialogDadosBaixaParcela(this)}
        {fuGetDialogCancelarReabrir(this)}
        {fuGetDialogDadosBoletoIndividual(this)}
        {fuGetLoadingEstorno(this)}
        {fuGetDialogEstornar(this)}
        {fuGetDialogEstornarParcelas(this)}
        {fuGetDialogUnirLancamento(this)}
        {fuGetDialogConfirmarFecharPedido(this)}
        {fuGetDialogConfirmarReajustarLancamento(this)}
        <LancamentoForm
          state={this.state}
          changeActiveIndex={this.changeActiveIndex}
          pagamento={this.props.pagamento}
          editarDadoFormaPagamento={this.props.editarDadoFormaPagamento}
          adicionarPagamento={this.props.adicionarPagamento}
          colunasPagamentos={colunasPagamento}
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          status={this.props.status}
          changeHandler={this.props.changeHandler}
          changeHandlerFormaPagamento={this.changeHandlerFormaPagamento}
          // Sem esta prop o painel do Pix Imediato (status, QR Code e copia-e-cola) nunca
          // renderiza: resolvePixImediato() lê props.pixImediato, que chegava undefined, e a
          // guarda de status/erro vazios devolvia null sempre. O mapStateToProps entrega
          // pixImediato ao container, e a barra de botões o enxerga de lá — por isso o
          // "Atualizar Status Pix" aparecia e o painel não, escondendo o defeito.
          pixImediato={this.props.pixImediato}
          getValorLancamentosFilhos={this.getValorLancamentosFilhos}
          editarNumeroParcelas={this.editarNumeroParcelas}
          estornarPagamento={this.estornarParcelas}
          desabilitarBotaoAdicionarPagamento={this.desabilitarBotaoAdicionarPagamento}
          desabilitarBotaoEstornarParcela={this.desabilitarBotaoEstornarParcela}
          desabilitarBotaoBaixarParcela={this.desabilitarBotaoBaixarParcela}
          desabilitarBotaoBoleto={this.desabilitarBotaoBoleto}
          desabilitarBotaoCarne={this.desabilitarBotaoCarne}
          abrirDialogBoletoIndividual={this.abrirDialogBoletoIndividual}
          gerarCarneParcelas={this.gerarCarneParcelas}
          onBlurValor={this.onBlurValor}
          onBlurValorFormaPagamento={this.onBlurValorFormaPagamento}
          onBlurValorParcela={this.onBlurValorParcela}
          onBlurValorDescontoAcrescimo={this.onBlurValorDescontoAcrescimo}
          calcularValorParcela={this.calcularValorParcela}
          clearFormPagamento={this.props.clearFormPagamento}
          onBlurNumeroParcelas={this.onBlurNumeroParcelas}
          calcularValorTotal={this.calcularValorTotal}
          changeHandlerValorLancamento={this.changeHandlerValorLancamento}
          onChangeValorDesconto={this.onChangeValorDesconto}
          onChangePercentualDesconto={this.onChangePercentualDesconto}
          onChangeTipoDesconto={this.onChangeTipoDesconto}
          onChangeValorMulta={this.onChangeValorMulta}
          onChangePercentualMulta={this.onChangePercentualMulta}
          onChangeTipoMulta={this.onChangeTipoMulta}
          onChangeValorJuros={this.onChangeValorJuros}
          onChangePercentualJuros={this.onChangePercentualJuros}
          onChangeTipoJuros={this.onChangeTipoJuros}
          onChangeJurosDia={this.onChangeJurosDia}
          displayForm={this.props.displayForm}
          showForm={this.props.showForm}
          showFormParcelas={this.showFormParcelas}
          onClickAdicionarParcela={this.onClickAdicionarParcela}
          record={this.props.record}
          onSelectionChange={this.onSelectionChange}
          selectedParcelas={this.props.selectedParcelas}
          abrirLancamento={this.abrirLancamento}
          history={this.props.history}
          onChangeHandlerConspagaPagarAte={this.onChangeHandlerConspagaPagarAte}
          onBlurConspagaPagarAte={this.onBlurConspagaPagarAte}
          //------
          lookupPagador={this.props.lookupPagador}
          lookupPagadorOnKeyPress={this.lookupPagadorOnKeyPress}
          lookupPagadorOnHide={this.lookupPagadorOnHide}
          lookupPagadorOnConfirm={this.lookupPagadorOnConfirm}
          lookupPagadorOnCancel={this.lookupPagadorOnCancel}
          lookupPagadorOnPage={this.lookupPagadorOnPage}
          lookupPagadorOnSort={this.lookupPagadorOnSort}
          lookupPagadorOnFilter={this.lookupPagadorOnFilter}
          lookupPagadorOnClick={this.lookupPagadorOnClick}
          lookupPagadorOnEdit={this.lookupPagadorOnEdit}
          lookupPagadorOnComplete={this.lookupPagadorOnComplete}
          lookupPagadorOnInputFilter={this.lookupPagadorOnInputFilter}
          //-----
          setContrato={this.setContrato}
          formasPagamento={this.props.formasPagamento}
          formasPagamentoBasica={this.props.formasPagamentoBasica}
          setField={this.props.setField}
          servicoCartaoCreditoVindi={this.props.servicoCartaoCreditoVindi}
          servicoBoletoVindi={this.props.servicoBoletoVindi}
          onChangeItemLancamento={this.onChangeItemLancamento}
          fnUpdateObservacao={this.fnUpdateObservacao}
          showMessageConspagaEmDia={this.props.showMessageConspagaEmDia}
          fatorMultiplicadorConspaga={this.props.fatorMultiplicadorConspaga}
          units={_.get(this, 'props.units', storage.getUnits())}
          currentCompany={_.get(this, 'props.currentCompany', storage.getCompany())}
          showWarningMessage={this.props.showWarningMessage}
          exibirConspaga={this.props.exibirConspaga}
          setFieldPagador={this.setFieldPagador}
          checkDocumentoPagador={this.checkDocumentoPagador}
          statePessoaFisica={this.props.statePessoaFisica}
          statePessoaJuridica={this.props.statePessoaJuridica}
          cartoesPagador={this.props.cartoesPagador}
          setMarcadores={this.setMarcadores}
          stateMarcador={this.props.stateMarcador}
          setNotaEntrada={this.setNotaEntrada}
          stateNotaEntrada={this.props.stateNotaEntrada}
          setContaCorrente={this.setContaCorrente}
          formaPagamentoOriginal={this.props.formaPagamentoOriginal}
          emiteNFSe={this.props.emiteNFSe}
          descontoAplicado={this.props.descontoAplicado}
          multaAplicada={this.props.multaAplicada}
          jurosAplicados={this.props.jurosAplicados}
          adicionandoAnexo={this.props.adicionandoAnexo}
          anexos={this.props.record.anexos}
          onSelectAnexo={this.props.addAnexo}
          downloadAnexo={this.props.downloadAnexo}
          removeAnexo={this.props.removeAnexo}
          acaoBloquearLancamento={this.state.BLOQUEAR_LANCAMENTO}
          acaoExibirAbaIntegracaoLancamento={this.state.ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO}
          alterarVendedor={this.state.ALTERAR_VENDEDOR}
          alterarAuxiliar={this.state.ALTERAR_AUXILIAR}
          atualizarProvisionamento={this.atualizarProvisionamento}
          onClickBaixarParcela={this.onClickBaixarParcela}
        />
      </div>
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LancamentoFormPageContainer)
